import React from "react";
import { useStoreState } from "ezStore";
import { useQuery } from "@apollo/client";
import { intl } from "LocaleWrapper";
import { FormGroup } from "@cofano/cck";
import { Language, Fields, hasOptionalFieldPermission } from "imports/Utils";
import DataFormat from "components/utils/DataFormat";
import { LocationLink, ShipLink } from "utils/LinkUtils";
import { FormattedDate } from "utils/DateUtils";
import { ActualPosition } from "../tabs/MapShipsTab";
import { GetShipOnMapDocument } from "__generated__/view/ships/graphql/ship.queries.generated";

const MapShipInformation = ({
	position,
	shipId,
}: {
	position?: ActualPosition;
	shipId: number;
}) => {
	const session = useStoreState(store => store.session);

	const { data } = useQuery(GetShipOnMapDocument, {
		variables: {
			id: shipId,
		},
	});

	return (
		<React.Fragment>
			{hasOptionalFieldPermission(session, Fields.SHIP, "contacts") && (
				<FormGroup label={Language("SHIPS_SHIPPER")} labelPlacement={"left-center"}>
					{DataFormat.shipperContact(data?.ship.contacts[0])}
				</FormGroup>
			)}

			{hasOptionalFieldPermission(session, Fields.SHIP, "capacityTon") && (
				<FormGroup label={Language("SHIP_TONNAGE_CERTIFICATES_DEPTH")} labelPlacement={"left-center"}>
					{data?.ship.capacityTon != null ? DataFormat.volumeTon(data.ship.capacityTon) : "-"}
					{"/"}
					{data?.ship.capacityM3  != null ? DataFormat.volumeM3(data.ship.capacityM3) : "-"}
				</FormGroup>
			)}

			{hasOptionalFieldPermission(session, Fields.SHIP, "bargeType") && (
				<FormGroup label={Language("BARGE_TYPE")} labelPlacement={"left-center"}>
					{data?.ship.bargeType ? intl.formatMessage({ id: data.ship.bargeType }) : "-"}
				</FormGroup>
			)}

			{hasOptionalFieldPermission(session, Fields.SHIP, "dimensions") && (
				<FormGroup label={Language("SHIPS_DIMENSIONS")} labelPlacement={"left-center"}>
					{DataFormat.shipDimensions(data?.ship)}
				</FormGroup>
			)}

			<FormGroup label={Language("SHIP")} labelPlacement={"left-center"}>
				<ShipLink ship={data?.ship} />
			</FormGroup>

			<FormGroup label={Language("MAPS_SPEED")} labelPlacement={"left-center"}>
				{DataFormat.kmH(position?.speed)}
			</FormGroup>

			<FormGroup label={Language("MAPS_TIMESTAMP")} labelPlacement={"left-center"}>
				<FormattedDate date={position?.timestamp} />
			</FormGroup>

			<FormGroup label={Language("MAPS_DESTINATION")} labelPlacement={"left-center"}>
				{position?.nextCall ? <LocationLink location={position.nextCall.location} /> : Language("UNKNOWN")}
			</FormGroup>
		</React.Fragment>
	);
};

export default MapShipInformation;
